<template>
    <div class="main">
        <a-card style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <!-- <router-link to="/vaccine-templates"
                style="font-size:14px;text-decoration:none;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p>
                <p>Back To Vaccine Template</p>

            </router-link> -->
            </div>


            <div class="card-container mt-2">
                <div>
                    <h3 style="font-size:18;line-height:45px">Batch Overview</h3>
                </div>
                <div>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Batch Id: </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.batchNumber ? poultryDetails.batchNumber :
                            'N/A' }}</div>
                        </a-col>
                    </a-row>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Customer Name: </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.customerName ? poultryDetails.customerName :
                            "N/A" }}</div>
                        </a-col>
                    </a-row>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Breed: </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.breedName ? poultryDetails.breedName : 'N/A' }}
                            </div>
                        </a-col>
                    </a-row>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Source: </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.source ? poultryDetails.source : 'N/A' }}</div>
                        </a-col>
                    </a-row>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Source ID: </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.sourceName ? poultryDetails.sourceName :
                            "N/A" }}</div>
                        </a-col>
                    </a-row>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Species: </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.poultrySpeciesLabel ?
                            poultryDetails.poultrySpeciesLabel : "N/A" }}</div>
                        </a-col>
                    </a-row>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Size: </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.size ? poultryDetails.size : "N/A" }}</div>
                        </a-col>
                    </a-row>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Age(days): </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.age ? poultryDetails.age : "N/A" }}</div>
                        </a-col>
                    </a-row>
                    <a-row class="pb-2">
                        <a-col :span="8">
                            <div style="font-size:15;">Template Name: </div>
                        </a-col>
                        <a-col :span="8" :offset="4">
                            <div style="font-size:15;">{{ poultryDetails.vaccineTemplateName ?
                            poultryDetails.vaccineTemplateName : "N/A" }}</div>
                        </a-col>
                    </a-row>
                </div>
            </div>

            <div class="mt-5">
                <div class="actions">
                    <h3 style="font-size:28px;line-height:45px">Vaccination Chart</h3>
                    <!-- <div style="display:flex; justify-content: space-around;">
                    <a-button @click="showVaccineModal" style="border-raduis:6px; background: #fff;color:#0F3659; margin-right:10px;" >
                        <a-icon type="plus" /> Add Product
                    </a-button>
                </div> -->
                </div>
                <a-table :columns="poultryColumns" :data-source="poultryDetails.vaccineSchedule"
                    :pagination="pagination" :loading='tableLoading' :scroll="{ x: 1500, y: 600 }" class="tableStyle">
                    <template slot="vaccinationStatusLabel" slot-scope="data">
                        <status-component :status="data"></status-component>
                    </template>
                    <template slot="reminderStatusLabel" slot-scope="data">
                        <status-component :status="data"></status-component>
                    </template>
                    <template slot="vaccinationOrderStatusLabel" slot-scope="data">
                        <status-component :status="data"></status-component>
                    </template>
                </a-table>
            </div>
        </a-card>

    </div>

</template>

<script>
import moment from 'moment';
// import XLSX from "xlsx";
// import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
// import Invoice from './custom/Invoice.vue'
// import DownloadInvoice from './custom/DownloadInvoice.vue'
import StatusComponent from '../shared-components/StatusComponent.vue'


const poultryColumns = [
    {
        title: 'Product Name',
        dataIndex: 'productName',
        key: 'productName',
        // width: 150,
    },
    {
        title: 'Category',
        dataIndex: 'productCategory',
        key: 'productCategory'
        // width: 200,
    },
    {
        title: 'Vaccination Status',
        dataIndex: 'vaccinationStatusLabel',
        key: 'vaccinationStatusLabel',
        scopedSlots: { customRender: 'vaccinationStatusLabel' },
        //  width: 150,
    },
    {
        title: 'Reminder Status',
        dataIndex: 'reminderStatusLabel',
        key: 'reminderStatusLabel',
        scopedSlots: { customRender: 'reminderStatusLabel' },
        //  width: 150,
    },
    {
        title: 'Order By Date',
        dataIndex: 'remindByDate',
        key: 'remindByDate',
        //  width: 150,
    },
    {
        title: 'Expected Vaccination Date',
        dataIndex: 'vaccinationDate',
        key: 'vaccinationDate',
        // width: 150,
    },
    {
        title: 'Order Status',
        dataIndex: 'vaccinationOrderStatusLabel',
        key: 'vaccinationOrderStatusLabel',
        scopedSlots: { customRender: 'vaccinationOrderStatusLabel' },
        // width: 150,
    },
];

export default {
    name: 'PoultryDetails',
    // props: ['items'],
    components: {
        // Invoice,
        // DownloadInvoice
        StatusComponent
    },
    data() {
        return {
            products: [],
            poultryDetails: {},

            addVaccineVisible: false,
            data: [],
            poultryColumns,
            dateFormat: 'DD/MM/YYYY',
            startDate: moment(),
            endDate: moment(),
            params: {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {}
            },
            pagination: {
                pageSize: 20
            },
            selectedProduct: {},
            tableLoading: false,
            addVaccineModel: {
                id: '',
                category: '',
                manufacturer: '',
                applicationAge: '',
                doseNumber: '',
                remindBy: '',
                notes: ''
            },
            id: '',
            loading: false,
            rules: {
                id: [
                    { required: true, message: 'Please select product', trigger: 'change' },
                ],
                category: [
                    { required: true, message: 'Please select product', trigger: 'change' },

                ],
                manufacturer: [
                    { required: true, message: 'Please select product', trigger: 'change' },
                ],
                applicationAge: [
                    { required: true, message: 'Please select your age', trigger: 'change' },
                ],
                doseNumber: [
                    { required: true, message: 'Please enter dose number', trigger: 'change' },
                ],
                remindBy: [
                    { required: true, message: 'Please enter remindBy', trigger: 'change' },
                ],
                notes: [
                    { required: true, message: 'Please enter notes', trigger: 'change' },
                ],
            }

        }
    },
    methods: {
        ...mapActions(['']),
        onChange(date, dateString) {
            // console.log(date, dateString);
            this.startDate = dateString[0];
            this.endDate = dateString[1];
            // console.log("startDate | ", this.startDate);
            // console.log("endDate | ", this.endDate);
        },
        moment,
        showVaccineModal() {
            this.addVaccineVisible = true;
        },
        closeVaccineModal() {
            this.addVaccineVisible = false;
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },

        onChangeProduct() {
            const productId = this.addVaccineModel.id
            const selectedProduct = this.products?.data?.find((product) => product.id === productId)
            if (selectedProduct) {
                this.selectedProduct = selectedProduct
                this.addVaccineModel.category = this.selectedProduct?.categoryName ?? 'N/A'
                this.addVaccineModel.manufacturer = this.selectedProduct?.manufacturerName ?? 'N/A'
            }
        },

        handleAddVaccine() {
            this.$refs.addVaccineRef.validate(async valid => {
                if (valid) {
                    this.loading = true;

                    const request = {
                        id: this.id,
                        data: {
                            productId: parseInt(this.addVaccineModel.id),
                            applicationAge: parseInt(this.addVaccineModel.applicationAge),
                            doseNumber: parseInt(this.addVaccineModel.doseNumber),
                            remindBy: parseInt(this.addVaccineModel.remindBy),
                            notes: this.addVaccineModel.notes
                        }
                    }

                    const response = await this.$store.dispatch("vaccineTemplate/addVaccine", request);

                    this.loading = false
                    if (response.status === 200) {
                        this.showSuccessAlert("New Vaccine Created Successfully")
                        this.getpoultryDetailss();
                        this.addVaccineModel = {
                            id: '',
                            category: '',
                            manufacturer: '',
                            applicationAge: '',
                            doseNumber: '',
                            remindBy: '',
                            notes: ''
                        }
                        this.addVaccineVisible = false;
                    } else {
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },

        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },

        async getProducts() {
            const request = {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {
                    "'brandName'": 'desc'
                }
            }
            const response = await this.$store.dispatch('vaccineTemplate/getProducts', request);
            if (response.status === 200) {
                this.products = response.data;
            } else {
                // console.log("Error | ", response);
                this.showErrorAlert(`Something went wrong,try again later`)
            }
        },

        async getpoultryDetailss() {
            this.id = this.$route.params.id;
            this.tableLoading = true;
            const response = await this.$store.dispatch('vaccineTemplate/getTemplateById', this.id);
            this.tableLoading = false;
            if (response.status === 200) {
                this.poultryDetails = response.data;
            } else {
                // console.log("Error | ", response);
                this.showErrorAlert(`Something went wrong,try again later`)
            }
        },

    },
    computed: {
        ...mapGetters(['getCustomer', 'getPoultry']),
        displayDate() {
            return moment(this.retailerExtraDetails.createdAt).format("DD-MMM-YYYY")
        },
        displayTotalShopCategory() {
            return this.tableShopCategories.length
        },
        displayTotalCustomerOrders() {
            return this.tableCustomerOrders.length
        }
    },
    created() {
        if (this.getPoultry) {
            let data = this.getPoultry
            this.poultryDetails = {
                ...data,
                remindByDate: moment(data.remindByDate).format("DD-MMM-YYYY HH:mm:ss"),
                vaccinationDate: moment(data.vaccinationDate).format("DD-MMM-YYYY HH:mm:ss"),
                vaccineSchedule: data.vaccineSchedule.map(schedule => ({
                    ...schedule,
                    key: schedule.id,
                    remindByDate: moment(schedule.remindByDate).format("DD-MMM-YYYY HH:mm:ss"),
                    vaccinationDate: moment(schedule.vaccinationDate).format("DD-MMM-YYYY HH:mm:ss")
                }))
            };
        } else {
            this.$router.push({
                name: 'customers',
            }).catch(() => { });
        }

    }
}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

a {
    color: #777777;
}

a:hover {
    color: #777777;
}

button:hover {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

.card-container {
    background: none;
    overflow: hidden;
    /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: #fff;
    padding: 16px;

}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}

.card-container>>>.ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.card-container>>>.ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
    border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
    border-color: #e5efe7;
    background: #e5efe7;
}

.requestActions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}


.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>